import { RequireOnly } from '@pelicargo/types';
import { ensureDimensionUnit, getHandlingAndPacking, getPrettyDimensionUnit, prettyNumber } from '@pelicargo/utils';
import { Cargo, DimensionUnit } from '@prisma/client';
import { isFinite } from 'lodash';

// Cargo is stored in cm, matching the Request.original_dimension_unit default.
export const summaryLine = (
  cargo: RequireOnly<Cargo, 'quantity' | 'length' | 'width' | 'height' | 'weight' | 'handling'>,
  dimensionUnit: DimensionUnit = DimensionUnit.cm,
) => {
  const dimensions = [cargo.length, cargo.width, cargo.height]
    .map((value) => prettyNumber(ensureDimensionUnit(value, dimensionUnit)))
    .join('×');

  return [
    `${prettyNumber(cargo.quantity)} Pcs`,
    `${dimensions} ${getPrettyDimensionUnit(dimensionUnit)}`,
    isFinite(cargo.weight) && `${prettyNumber(cargo.weight)} kg`,
    getHandlingAndPacking(cargo),
  ]
    .filter(Boolean)
    .join(' | ');
};
